import React, { useEffect, useState } from "react";
import { Button, DocumentsList, Modal, StatusTags, TableAdv } from "../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../utils";
import { documentTableData } from "../../../../../assets/data/candidatesData";
import { useDispatch, useSelector } from "react-redux";
import { getAllDocumentsStart } from "../../../../../redux/slices/document/documentSlice";
import { transformFiles } from "../../../../../utils/transformFiles";

const DocumentsTab = () => {
  const dispatch = useDispatch();
  const { loading, error, employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee
  );
  const documents = useSelector(
    (state) => state.documents.documents
  )||[];
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  console.log('selectedDocuments',selectedDocuments);
  const [documentModal, setDocumentModal] = useState(false);
  const handleclick = (row) => {
    setDocumentModal(!documentModal);
    setSelectedDocuments(row)
  };
  const tableData = documents||[];
  const columns = [
    {
      key: "docType",
      label: "Document Type",
    },
    {
      key: "title",
      label: "Title",
    },
    {
      key: "docStatus",
      label: "Status",
      render: (row) => row.docStatus?<StatusTags tag={row.docStatus} />:"",
    },
    {
      key: "docExpiry",
      label: "Expiry Date",
      render: (row) => row.docExpiry? dateFormator(row.docExpiry, "month-day-year"):"",
    },
    {
      key: "file",
      label: "Documents",
      render: (row) => (
        <div
          className="flex items-center gap-1 flex-row cursor-pointer"
            // onClick={() => handleclick(row)}
          onClick={
                        transformFiles(([row]||[])).length > 0
                          ? () => handleclick(transformFiles(([row]||[])))
                          : () => {}
                      }
        >
          <span className="text-linkblue" 
           
          >
           {transformFiles([row]).length} Docs{" "}
          </span>
          {/* <div>
            <Button
              type="icon"
              icon="docs"
              size="xs"
              variant="text"
              color="black"
            />
          </div> */}
        </div>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <Button
            type="icon"
            icon="edit"
            size="xs"
            variant="text"
            color="black"
          />
          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
          />
        </div>
      ),
    },
  ];
  console.log('tableData',tableData);
  const mappedRows = mapTableRows(tableData, columns);
  useEffect(() => {
   const filter={"parent.employee" : { "type": "NONE", "value": employeeProfileUiid }, "docType": { "type": "EXCLUDE", "value": ["Passport", "I94", "Everify", "certified LCA", "online Paper", "Visa"] } }
    if (employeeProfileUiid && !loadedTabs.includes("documentsTab")) {
      dispatch(
        getAllDocumentsStart({
          cache: false,
          uiid: employeeProfileUiid,
          tab: "documentsTab",
          ret: "document",
          type:"ref.id",
          coll: "Document",
          filter
        })
      );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch]);
  return (
    <div className="mt-3">
      <TableAdv tableId={`employee_documents_documentstab`} rows={mappedRows} columns={columns}  />
      <Modal
        isOpen={documentModal}
        onClose={() => setDocumentModal(false)}
        title="Document Details"
      >
       <DocumentsList data={selectedDocuments} />
      </Modal>
    </div>
  );
};

export default DocumentsTab;
